// IE 2026 10 15 / ODOO-5512 (ie-engine7 14.10 via ie-webscm7 #86527): chips inside an AttrGrid cell (AttrGrid.vue, formatItem_cells and the
// formatItem cache path) — pure logic without wijmo / DOM, so it can be unit-tested (tests/unit/cellChipsBackspace.test.mjs).
//
// 1. Backspace in the empty chip input used to do `valueC.pop()` (80414ef54): it dropped the LAST ARRAY ROW, even an invisible one (use: false),
//    without an undo entry and without setModified. Now Backspace hides the last VISIBLE chip the same way the ⊗ button does
//    (AttrGrid.chipRemove_apply: use = false + hist_push + setModified); nothing happens when no chip is visible.
//    cellChips_lastVisible(arr) → index of the last visible chip: a scalar (record id in an id list) or a row with use !== false; -1 if none.
// 2. The chip input created on the cache path (14cc970435, b631ce589) had no handlers (Enter did nothing). Both paths now go through
//    AttrGrid.chipInput_bind(input, ctx); cellChips_bindOnce(el) marks the element so the handlers are attached once per element.

export const CELL_CHIPS_BOUND = '__cellChipsBound'

function isScalar(v) { return v !== null && v !== undefined && typeof v !== 'object' && typeof v !== 'function' }

export function cellChips_visible(item) {
    if (item === null || item === undefined) return false
    if (isScalar(item)) return true
    return item.use !== false
}

export function cellChips_lastVisible(arr) {
    if (!Array.isArray(arr)) return -1
    for (let i = arr.length - 1; i >= 0; i--) if (cellChips_visible(arr[i])) return i
    return -1
}

// → true on the first call for this element (handlers must be attached now), false afterwards (already bound)
export function cellChips_bindOnce(el, key = CELL_CHIPS_BOUND) {
    if (!el || typeof el !== 'object') return false
    if (el[key]) return false
    el[key] = true
    return true
}
